import React from 'react';
import { Typography, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import contentLoadingImg from 'Images/content_loading.png';

const styles = theme => ({
  contentRoot: {
    padding: theme.spacing(6),
  },
  flexAlignVerticalCenter: {
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center',
    alignItems: 'center',
  },
  contentStatusImg: {
    height: 440,
    width: 440,
    margin: 'auto',
  },
  submitButton: {
    width: 400,
    borderRadius: 6,
    backgroundColor: '#000000',
    marginTop: 58,
    color: '#FFFFFF',
  },
});

class NoResults extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div
        className={classNames(
          classes.flexAlignVerticalCenter,
          'fullHeight',
          classes.contentRoot
        )}
      >
        <img src={contentLoadingImg} className={classes.contentStatusImg} />
        <div className={classNames('contentTopMargin')}> </div>
        <Typography color="textSecondary">
          No users found. <br /> Would you like to create one?
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          className={classes.submitButton}
          onClick={this.props.handleClick}
        >
          Create a Relocation Request
        </Button>
      </div>
    );
  }
}

NoResults.propTypes = {
  classes: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
};

NoResults = compose(withStyles(styles, { withTheme: true }))(NoResults);

export default NoResults;
